import { Component, Input } from '@angular/core';
import { DataSourceCard } from '../../models/data-connection';

@Component({
  selector: 'app-data-connection-stepper',
  templateUrl: './data-connection-stepper.component.html',
  styleUrl: './data-connection-stepper.component.scss',
})
export class DataConnectionStepperComponent {
  @Input() stepper: number = 0;
  @Input() selectedDatasource?: DataSourceCard | null;
}
